<div fxLayout="column" [ngStyle]="{'max-height.px': innerHeight}" class="layout-padd">

    <div fxLayoutAlign="center center" fxLayout="column" fxLayoutGap="20px" class="layout-padd">
        <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center center">
            <mat-icon color="warn">warning</mat-icon>
            <div> {{"warning"|translate}}</div>

        </div>
        <div *ngIf="productsToDeletetoBasket && productsToDeletetoBasket.length >0">
            {{ (productsToDeletetoBasket.length >=1 ?"productsExpiredText":"productExpiredText")|translate}}

        </div>
    </div>


    <div fxLayout="column" class="layout-padd scrolled mat-dialog-content" fxLayoutGap="25px">

        <mat-list>



            <mat-divider *ngIf="productsToDeletetoBasket.length >0"></mat-divider>

            <div *ngFor="let prod of productsToDeletetoBasket; let last = last;">

                <mat-list-item>
                    <img matListAvatar [src]="prod.image[0] ? prod.image[0] : '/assets/img/not-found.png'">
                    <div matLine>
                        <span style="padding-left: 5px;"> {{prod.display_lang.name}}</span>
                        <div fxFlex></div>
                    </div>
                </mat-list-item>

                <div *ngIf="prod.details &&prod.details.length> 0" fxLayout="column"
                    style="font-size: x-small;padding-left: 80px; margin-top: -20px;margin-bottom: 20px;">
                    <div *ngFor="let sdet of prod.details">
                        <div *ngIf="sdet.dateChange">

                            <span> - {{sdet.display_lang.name}}</span>
                        </div>

                        <div *ngIf="sdet.details && sdet.details.length> 0">
                            <div *ngFor="let ssdet of sdet.details">

                                <div *ngIf="ssdet.dateChange">
                                    <span> - {{ssdet.display_lang.name}}</span>
                                </div>


                            </div>

                        </div>
                    </div>
                </div>
                <mat-divider *ngIf="!last"></mat-divider>
            </div>

        </mat-list>

    </div>




    <div fxLayoutAlign="center center" class="layout-padd">

        <button mat-stroked-button class="dark-ico full-w " (click)="closeDial()" angulartics2On="click">
            <span class="mat-title"> {{'dialogs.go-back'|translate }}</span>
        </button>

    </div>


</div>
